import rest from "@/rest-client";

export const accountWorkspaceOrganization = {
  namespaced: true,
  persistent: ["activeTab"],
  state: {
    activeTab: undefined,
  },
  getters: {
    activeTab: (state) => state.activeTab,
  },
  mutations: {
    activeTab: (state, value) => (state.activeTab = value),
  },
  actions: {
    activeTab: ({ commit }, value) => commit("activeTab", value),
  },
};

export const managementPurchasedOrganizationFeature = {
  namespaced: true,

  actions: {
    async update({ getters, commit, dispatch }, payload) {
      const response = await rest.post(`/management/purchased-feature-organization`, payload);
      return response;
    },
  },
};
export const managementPurchasedWorkspaceFeature = {
  namespaced: true,

  actions: {
    async update({ getters, commit, dispatch }, payload) {
      const response = await rest.post(`/management/purchased-feature-workspace`, payload);
      return response;
    },
  },
};
